import {BaseDataSource} from './BaseDataSource';
import {Log} from '../Entities/Log';
import {LogService} from '../../services/log.service';
import {Pagination} from '../Helpers/Pagination';
import {SortInfo} from '../Helpers/SortInfo';
import {Filter} from '../Helpers/Filter';
import {Observable} from 'rxjs/Observable';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {DataSource} from '@angular/cdk/collections';

export class LogDataSource extends DataSource<Log> {
    _data: BehaviorSubject<Log[]> = new BehaviorSubject<Log[]>([]);
    dataSize: Number = 0;
    summary = {};

    private objectType: string;
    private objectId: number;

    constructor(private logService: LogService) {
        super();
    }

    setObjectParams(objectType: string, objectId: number): void {
        this.objectType = objectType;
        this.objectId = objectId;
    }

    connect(): Observable<Log[]> {
        return this._data;
    }

    disconnect() {
    }

    loadPage(pagination: Pagination, sort: SortInfo = null, filters: Filter[] = [], params: Object = {}) {
        if (!this.objectType || !this.objectId) {
            return;
        }

        return this.logService.getLogsForObject(
            this.objectType,
            this.objectId,
            pagination,
            sort,
            filters,
            params
        ).subscribe(data => {
            this.dataSize = data.pagination.total;
            this.summary = data.summary;
            this._data.next(data.results);
        });
    }

    getData(): Log[] {
        return this._data.getValue();
    }

    getSummary(): any {
        return this.summary;
    }
}



// WEBPACK FOOTER //
// /app/src/model/DataSources/LogDataSource.ts